import { Col, Row } from "antd";
import React from "react";
import profile from "../../../../assets/icons/profile-3.svg";
import Aggregator from "../../../../assets/icons/aggregator_leaf.svg";
import accessMapping from "../../../../CommonComponents/accessMapping";
import { AlignItemsCenter, BlurContainer, DisplayFlex, EllipsisContent, EllipsisDataValueWrapper, EllipsisUnderline, PrimaryIndicator } from "../../../../CommonComponents/commonStyles";
import HyperLinkComponent from "../../../../CSR/CommonComponents/HyperLinkComponent/HyperLinkComponent";
import { ENTITY_OVERVIEW_URL } from "../../../../CSR/utils/geminiUrlMapper";
import history from "../../../../history/history";
import { initiateTracking,recordError} from "../../../../utils/commonUtil";
import { getPrimaryAccount, isGeminiUser } from "../../../../utils/sessionUtil";
import { ItemData, ItemHeading, PersonnelHeading, InlineDiv } from "../../styles";
import { AddBody, AddPillAccount, PillButtonAddd } from "./styles";
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
import { isNewAdvent, sortAggrDates } from "../../utils";


export function accessMappingData(data) {
  return accessMapping[data];
}


export function CountryCodeMappingData1(data,{countryCodeMappingData}) {
  let countryName;
  if (countryCodeMappingData) {
    countryCodeMappingData.map(item => {
      if (item.value == data) {
        countryName = item.desc;
      }
    })
  };
  return countryName;
}

export function goToInviteParties(link) {
try {
  initiateTracking("interestedParty", "My Account", "Interested Party Details", "Add interested party")
  history.push(link)
} catch (error) {
  recordError(error);
}
}

export default function WebView(props) {
  const { accData = [], addBtn, roledetails } = props;
  return (
    <>
      <Row type="flex" >
        {accData.length > 0 ? (
          accData.map((item, index) => (
            <Col key={index} lg={8} md={8} xs={24} className={index > 2 ? "mt3" : ""}>
              <Row>
                <Col lg={2} md={2} xs={2}>
                  <img src={profile} alt="profileIcon" />
                </Col>
                <Col lg={22} md={22} xs={22}>
                  <AlignItemsCenter className="mb1">
                    <PersonnelHeading>
                      Interested Party {index + 1}
                    </PersonnelHeading>
                    {item.primaryAccountContact ? (
                      <PrimaryIndicator className="ml2">
                        Primary
                      </PrimaryIndicator>
                    ) : (
                        ""
                      )}
                  </AlignItemsCenter>
                  {
                    isGeminiUser() ? 
                      <ItemData>
                        <HyperLinkComponent
                          to={`${ENTITY_OVERVIEW_URL}?partyId=${item.partyId}`}
                          text={
                            ( 
                              !item.name &&
                              !item.salutation &&
                              !item.middleName &&
                              !item.lastName &&
                              !item.suffix  )? (
                              <> &mdash; </>
                            ) : (
                              ((item.salutation ? item.salutation + " " : '') + (item.name ? item.name + " " : '') + (item.middleName ? item.middleName + " " : "") + (item.lastName ? item.lastName : "") + (item.suffix ? ", " + item.suffix : ""))
                            )}
                        />
                        </ItemData> :
                        <ItemData className="mt0">
                      
                        {
                        ( 
                          !item.name &&
                          !item.salutation &&
                          !item.middleName &&
                          !item.lastName &&
                          !item.suffix  )? (
                          <> &mdash; </>
                        ) : (
                          ((item.salutation ? item.salutation + " " : '') + (item.name ? item.name + " " : '') + (item.middleName ? item.middleName + " " : "") + (item.lastName ? item.lastName : "") + (item.suffix ? ", " + item.suffix : ""))
                        )}
                      </ItemData>
                  }
                  
                  <DisplayFlex className="mt-05">
                    <ItemHeading>Email :</ItemHeading>
                    <ItemData className="mt0 ml-05">
                      {item.email === null || item.email === "" ? (
                        <> &mdash; </>
                      ) : (
                            <EllipsisDataValueWrapper>
                              <EllipsisUnderline>{item.email}</EllipsisUnderline>
                              <EllipsisContent>
                                {item.email}
                              </EllipsisContent>
                            </EllipsisDataValueWrapper>
                        )}
                    </ItemData>
                  </DisplayFlex>
                  <DisplayFlex className="mt-05">
                    <ItemHeading>Phone :</ItemHeading>
                    <ItemData className="mt0 ml-05">
                      {item.phone === null || item.phone === "" ? (
                        <> &mdash; </>
                      ) : (
                          item.phone
                        )}
                    </ItemData>
                  </DisplayFlex>
                  {item.relation === "Professional Advisor" ? (
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Firm Name :</ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {item.firm === null || item.firm === "" ? (
                          <> &mdash; </>
                        ) : (
                            item.firm
                          )}
                      </ItemData>
                    </DisplayFlex>
                  ) : (
                      ""

                    )}
                  <DisplayFlex className="mt-05">
                    <ItemHeading>Address :</ItemHeading>
                    <div>
                      <ItemData className="mt0 ml-05">
                        {item.address.address ? `${item.address.address}, ` : ''}
                      </ItemData>
                      <ItemData className="mt0 ml-05">
                        {item.address.addressLine1 ? `${item.address.addressLine1}, ` : ''}
                      </ItemData>
                      <ItemData className="mt0 ml-05">
                        {item.address.addressLine2 ? `${item.address.addressLine2}, ` : ''}
                      </ItemData>
                      <ItemData className="mt0 ml-05">
                        {item.address.addressLine3 ? `${item.address.addressLine3}, ` : ''}
                      </ItemData>
                      <ItemData className="mt0 ml-05">
                        {item.address.city ? `${item.address.city}, ` : ""} {item.address.state? `${item.address.state}, `: " "}
                        {item.address.zipCode? `${item.address.zipCode}, `: ""}
                      </ItemData>
                      <ItemData className="mt0 ml-05">
                        {CountryCodeMappingData1(item.address.country,props)}
                      </ItemData>
                    </div>
                  </DisplayFlex>

                  <DisplayFlex className="mt-05">
                    <ItemHeading>Account Role :</ItemHeading>
                    <ItemData className="mt0 ml-05">{item.role === "Trusted Advisor" ? "Professional Advisor " : item.role = "Designated Party" ? "Interested Party" : item.role}</ItemData>
                  </DisplayFlex>

                  <DisplayFlex className="mt-05">
                    <ItemHeading>Relation :</ItemHeading>
                    <ItemData className="mt0 ml-05">
                      {item.relation === null || item.relation === "" ? (
                        <> &mdash; </>
                      ) : (
                        item.relation
                        )}
                    </ItemData>
                  </DisplayFlex>
                  <DisplayFlex className="mt-05">
                    <ItemHeading>Access Level :</ItemHeading>
                    <ItemData className="mt0 ml-05">
                      {accessMappingData(item.access)}
                    </ItemData>
                  </DisplayFlex>
                  {item.dataAggregators && item.dataAggregators.length ?
                    (<DisplayFlex className="mt-05">
                      <ItemHeading>Data Aggregator :</ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {sortAggrDates(item.dataAggregators).map((agg, cnt) => {
                          if (item.dataAggregators.length - 1 === cnt) return agg.aggrName;
                          else return agg.aggrName + ', ';
                        })}
                         {isNewAdvent(item.dataAggregators) ? (
                          <InlineDiv>
                            <img src={Aggregator} className="aggregator_iconleaf" alt="aggregator" />
                            <span className="aggregator_newbtn">New</span></InlineDiv>
                        ) : <></>}
                      </ItemData>
                    </DisplayFlex>) : <></>}
                  { isGeminiUser() && 
                    <BlurContainer className="gemini-notes-info-container">
                        <DisplayFlex className="mt-05">
                            <ItemHeading>Web Access: </ItemHeading>
                            <ItemData className="mt0 ml-05">
                                {item.webAccess ? (
                                    item.webAccess  
                                ) : (
                                    <> &mdash; </>
                                )}
                            </ItemData>
                        </DisplayFlex>
                        <DisplayFlex className="mt-05">
                            <ItemHeading> Permission to share: </ItemHeading>
                            <ItemData className="mt0 ml-05">
                                {item.permissionToShare ? (
                                    item.permissionToShare  
                                ) : (
                                    <> &mdash; </>
                                )}
                            </ItemData>
                        </DisplayFlex>
                    </BlurContainer>
                }
                </Col>
              </Row>
            </Col>
          ))
        ) : (
            <ItemHeading>No Data found</ItemHeading>
          )}
      </Row>
      {addBtn ? (
        <AddBody className={getPrimaryAccount().role.access === "Read Only" ? "disable" : ""}>
          {roledetails !== "Account Advisor" ? (
            
            <CapsuleButton text="Add interested party" iconType="add"  disabled whiteBackground/>
          

          ) :

<CapsuleButton text="Add interested party" iconType="add" width="227px" lineHeight="1.25rem" id="btnPillButtonAddd" onClick={() => goToInviteParties("/my-account/invite-interested-parties")}/>
     
          }
        </AddBody>
      ) : (
          ""
        )}
    </>
  );
  }